module.exports = __webpack_public_path__ + "static/media/Times New Roman.bf0b0955.ttf";